export const INSTALLATION_METHOD_BITRISE_STEP = 'Trace step';

export const ACTIVE_THRESHOLD_DAYS_QUIET = -5;
export const ACTIVE_THRESHOLD_DAYS_INACTIVE = -15;
